import { render, staticRenderFns } from "./TinyEditor.vue?vue&type=template&id=4c2ef395"
import script from "./TinyEditor.vue?vue&type=script&lang=js"
export * from "./TinyEditor.vue?vue&type=script&lang=js"
import style0 from "./TinyEditor.vue?vue&type=style&index=0&id=4c2ef395&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports